import React from 'react';
import { authService } from '../services/authService';
import GoogleSignIn from './GoogleSignIn';

const ProtectedRoute = ({ children, onAuthChange }) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);

  // Check authentication state on mount and listen for changes
  React.useEffect(() => {
    // Initial auth check
    const sessionRestored = authService.restoreSession();
    const serviceAuthenticated = authService.isUserAuthenticated();
    const actuallyAuthenticated = sessionRestored && serviceAuthenticated;

    console.log('Initial auth check:', { sessionRestored, serviceAuthenticated, actuallyAuthenticated });

    setIsAuthenticated(actuallyAuthenticated);
    setIsLoading(false);

    if (onAuthChange) {
      onAuthChange(actuallyAuthenticated);
    }

    // Listen for auth state changes
    const unsubscribe = authService.addAuthStateListener((isAuth, user) => {
      console.log('Auth state changed:', { isAuth, user });
      setIsAuthenticated(isAuth);
      if (onAuthChange) {
        onAuthChange(isAuth);
      }
    });

    // Cleanup listener
    return unsubscribe;
  }, [onAuthChange]);

  const handleAuthSuccess = (result) => {
    setIsAuthenticated(true);
    if (onAuthChange) {
      onAuthChange(true);
    }
  };

  const handleAuthError = (error) => {
    console.error('Authentication error:', error);
    setIsAuthenticated(false);
    if (onAuthChange) {
      onAuthChange(false);
    }
  };

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <GoogleSignIn
          onSuccess={handleAuthSuccess}
          onError={handleAuthError}
        />
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;